import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CheckoutService} from '../services/checkout.service';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {MatChipInputEvent, MatSnackBar} from '@angular/material';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import {FormControl, Validators} from "@angular/forms";
import {ParticipateService} from "../services/participate.service";

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.styl']
})
export class ShareComponent implements OnInit {

  purchase = {
    description: '',
    extra_description: null,
    total_value: 0,
    suggested_participation: 0,
    current_value: 0,
    customer: {
      document_number: '',
      name: '',
      main_img: '',
      url: ''
    }
  };
  purchase_id = '';
  participation_link = environment.participation_link;
  @ViewChild('inputLink') input_link: ElementRef;

  chip_emails = [];
  contacts_not_send = [];
  keysChipEmailSeparators = [ENTER, COMMA, SPACE];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checkoutService: CheckoutService,
              private participateService: ParticipateService,
              public snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.loadPurchase();
  }


  loadPurchase() {
    this.route.params.subscribe((params) => {
      this.purchase_id = params.purchaseId;
      this.checkoutService.getPurchase(params.purchaseId)
        .subscribe(purchase => {
            this.purchase = purchase;
          },
          error => {
            this.router.navigate(['404']);
          });
    });
  }

  copyLink() {
    this.input_link.nativeElement.select();
    document.execCommand('Copy');
    this.snackBar.open('El link se ha guardado en el portapapeles', 'OK', {
      duration: 2000,
    });
  }

  addEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const email_validation = new FormControl(value.trim(), [Validators.email]);
      if (email_validation.valid) {
        this.chip_emails.push({name: value.trim()});
        if (input) {
          input.value = '';
        }
      } else {
        this.snackBar.open('Ingresa un email valido', 'OK', {
          duration: 2000,
        });
      }
    }
  }

  removeEmail(email: any): void {
    const index = this.chip_emails.indexOf(email);

    if (index >= 0) {
      this.chip_emails.splice(index, 1);
    }
  }

  sendEmails() {
    if (this.chip_emails.length > 0) {
      const contacts = [];
      this.chip_emails.map((contact) => {
        contacts.push(contact.name);
      });
      this.participateService.sendEmailInvite(JSON.stringify(contacts), this.route.snapshot.params['purchaseId']).subscribe((data: any) => {
        this.contacts_not_send = data.contacts_not_send;
        this.snackBar.open('!Correos enviados con exito!', 'OK', {
          duration: 3000,
        });
        this.chip_emails = [];
      });
    } else {
      this.snackBar.open('Ingresa por lo menos un correo', 'OK', {
        duration: 3000,
      });
    }
  }

  backToCommerce() {
    document.location.href = this.purchase.customer.url;
  }


}



// WEBPACK FOOTER //
// ./src/app/share/share.component.ts